import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxInput from '../../cx/CxInput'; 
import CxState from '../../cx/CxState'; 
import CxSnackbar from '../../cx/CxSnackbar';
import * as FxFetch from '../../fx/FxFetch';
import GxForm from '../../gx/GxForm';

const MxSettShopify = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const r_snack_save = React.useRef(null);
  const r_snack_required = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_boActive = React.useRef(null);
  const rf_url = React.useRef(null);
  const rf_token = React.useRef(null);
  const rf_location = React.useRef(null);
  const rf_version = React.useRef(null);

  React.useEffect(() => {
    formLoad();
  }, []);

  const formLoad = async () => {
    let record = {};
    // Recupera los datos guardados en s_app
    Promise.all([FxFetch.doJsonX('sett/shopify/r', record)]).then((result) => {
      if (result[0]) {
        rf_boActive.current.setVal(result[0].shopify_active);
        rf_url.current.setVal(result[0].shopify_shop_url);
        rf_token.current.setVal(result[0].shopify_access_token);
        rf_location.current.setVal(result[0].shopify_location_id);
        rf_version.current.setVal(result[0].shopify_api_version);
      }
    });
  }

  const formSaveCustom = async () => {
    // Control de campos obligatorios
    if (rf_url.current.isEmpty()) {
      r_snack_required.current.setValAndOpen(trans('field.required') + ": " + rf_url.current.getLabel());
      return;
    }
    if (rf_token.current.isEmpty()) {
      r_snack_required.current.setValAndOpen(trans('field.required') + ": " + rf_token.current.getLabel());
      return;
    }
    if (rf_location.current.isEmpty()) {
      r_snack_required.current.setValAndOpen(trans('field.required') + ": " + rf_location.current.getLabel());
      return;
    }
    if (rf_version.current.isEmpty()) {
      r_snack_required.current.setValAndOpen(trans('field.required') + ": " + rf_version.current.getLabel());
      return;
    }

    let record = {};
    record['shopify_active'] = rf_boActive.current.getVal();
    record['shopify_shop_url'] = rf_url.current.getVal();
    record['shopify_access_token'] = rf_token.current.getVal();
    record['shopify_location_id'] = rf_location.current.getVal();
    record['shopify_api_version'] = rf_version.current.getVal();

    Promise.all([FxFetch.doJsonF("sett/shopify/u", null, record)]).then((result) => {
      if (result[0] && result[0].theStatus === 'OK') {
        r_snack_save.current.setOpen(true);
      }
    });
  }

  return (
    <div>
      <GxForm
        moduleName="Shopify - Configuración"
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew 
              icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} 
              classType="ibs_iconbutton_toolbar" 
              onClick={() => formSaveCustom()} 
              tooltip={trans('field.save_and_exit')} 
            />
          </div>
        }
      >
        <CxState mode='checkbox' xref={rf_boActive} label={trans('field.active_1')} />
        <CxInput xref={rf_url} label="Shopify URL" labelTooltip={"eg: iberical-test-basic.myshopify.com"} required />
        <CxInput xref={rf_token} label="Admin API Access Token" labelTooltip={"eg: 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"} required />
        <CxInput xref={rf_location} label={`Location ID`} labelTooltip={"eg: 111729312114"} required />
        <CxInput xref={rf_version} label="API Version" labelTooltip={"eg: 2026-01"} required />
      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_required} severity="error" />
    </div>
  );
}

export default MxSettShopify;
